<script setup lang="ts">
import { useAuthStore } from '~/stores/use-auth-store';

const route = useRoute();
const authStore = useAuthStore();
const isHome = computed(() => route.path === '/' || route.path === '/browse');

const loginUrl = computed(() => {
  if (route.path === '/login') return '/login';
  return `/login?redirect_to=${encodeURIComponent(route.fullPath)}`;
});

function handleLogout() {
  authStore.logout();
  navigateTo('/browse');
}
</script>

<template>
  <v-app-bar flat color="surface" border="b">
    <v-app-bar-title>
      <NuxtLink
        to="/"
        class="text-decoration-none text-on-surface d-inline-flex align-center"
        aria-label="Arvee Events home"
      >
        <CommonAppLogo />
        <CommonBetaBadge />
      </NuxtLink>
    </v-app-bar-title>

    <template #append>
      <v-btn
        to="/browse"
        variant="text"
        color="primary"
        class="mr-2"
        aria-label="Browse events"
      >
        Browse
      </v-btn>

      <template v-if="authStore.isAuthenticated">
        <v-btn
          v-if="isHome"
          to="/dashboard"
          variant="tonal"
          color="primary"
          class="mr-2"
        >
          Dashboard
        </v-btn>

        <v-menu>
          <template #activator="{ props }">
            <v-btn icon v-bind="props">
              <CommonUserAvatar :user="authStore.user!" :size="32" />
            </v-btn>
          </template>

          <v-list min-width="200">
            <v-list-item>
              <v-list-item-title class="font-weight-medium">
                {{ userDisplayName(authStore.user!) }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ authStore.user?.email }}
              </v-list-item-subtitle>
            </v-list-item>
            <v-divider />
            <v-list-item to="/dashboard" prepend-icon="mdi-view-dashboard">
              Dashboard
            </v-list-item>
            <v-divider />
            <v-list-item prepend-icon="mdi-logout" @click="handleLogout">
              Log out
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <template v-else>
        <v-btn
          v-if="isHome"
          to="/dashboard"
          variant="tonal"
          color="primary"
          class="mr-2"
        >
          Dashboard
        </v-btn>
        <v-btn :to="loginUrl" variant="outlined" color="primary">
          Log in
        </v-btn>
      </template>
    </template>
  </v-app-bar>
</template>
